const DEBUG = import.meta.env.DEV;

class UIManager {
  constructor() {
    this.elements = {
      app: document.getElementById('app'),
      main: document.getElementById('main'),
      header: document.getElementById('header'),
      loading: document.getElementById('loading'),
      error: document.getElementById('error'),
      errorText: document.getElementById('error-text'),
      errorRetryBtn: document.querySelector('.error-retry-btn'),
      spotCount: document.getElementById('spot-count'),
    };
  }

  showLoading() {
    if (DEBUG) {
      console.log('⏳ Showing loading indicator');
    }
    this.elements.loading.classList.remove('hidden');
  }

  hideLoading() {
    if (DEBUG) {
      console.log('✓ Hiding loading indicator');
    }
    this.elements.loading.classList.add('hidden');
  }

  showError(message) {
    console.error('❌ Error:', message);
    this.elements.errorText.textContent = message;
    this.elements.error.classList.remove('hidden');
  }

  hideError() {
    this.elements.error.classList.add('hidden');
  }

  onErrorRetry(callback) {
    this.elements.errorRetryBtn.addEventListener('click', callback);
  }

  updateSpotCount(count) {
    const text = count === 1 
      ? '1 fishing spot nearby'
      : `${count} fishing spots nearby`;
    this.elements.spotCount.textContent = text;
  }

  showNotification(message, type = 'info', duration = 3000) {
    if (DEBUG) {
      console.log(`📢 Notification (${type}):`, message);
    }

    // Create notification element
    const notification = document.createElement('div');
    notification.className = `notification notification-${type}`;
    notification.textContent = message;
    notification.style.cssText = `
      position: fixed;
      bottom: 20px;
      right: 20px;
      background-color: ${type === 'error' ? '#D32F2F' : type === 'success' ? '#388E3C' : '#1976D2'};
      color: white;
      padding: 16px;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
      z-index: 1000;
      animation: slideIn 0.3s ease-out;
      max-width: 300px;
    `;

    document.body.appendChild(notification);

    if (duration > 0) {
      setTimeout(() => {
        notification.style.animation = 'slideOut 0.3s ease-out';
        setTimeout(() => {
          document.body.removeChild(notification);
        }, 300);
      }, duration);
    }

    return notification;
  }
}

// Add CSS animation to style tag
if (!document.querySelector('style[data-animations]')) {
  const style = document.createElement('style');
  style.setAttribute('data-animations', 'true');
  style.textContent = `
    @keyframes slideIn {
      from {
        transform: translateX(400px);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }

    @keyframes slideOut {
      from {
        transform: translateX(0);
        opacity: 1;
      }
      to {
        transform: translateX(400px);
        opacity: 0;
      }
    }
  `;
  document.head.appendChild(style);
}

export { UIManager };
